import { belongsTo, hasMany } from '@ember-data/model';

import UnauthenticatedAppointmentModel from './unauthenticated-appointment';

export default class GroupAppointment extends UnauthenticatedAppointmentModel {
  @hasMany('invoice-item', { async: false, inverse: null }) invoiceItems;
  @belongsTo('appointment-client', { async: false, inverse: null }) appointmentClient;

  get fee() {
    return this.appointmentClient.fee;
  }

  get displayStatus() {
    if (this.isPastDue) {
      return 'past due';
    } else if (this.paid) {
      return 'paid';
    } else {
      return 'unpaid';
    }
  }

  get badgeClass() {
    if (this.isPastDue) {
      return 'primary wine';
    } else if (this.paid) {
      return 'secondary mint';
    } else {
      return 'secondary wine';
    }
  }

  get totalAllocatedAmount() {
    return this.invoiceItems.reduce((total, invoiceItem) => {
      return total + invoiceItem.allocatedAmount;
    }, 0);
  }

  get paid() {
    const invoices = this.uniqueInvoices;
    return invoices.length > 0 && invoices.every(invoice => invoice.isPaid);
  }

  get isPastDue() {
    return this.uniqueInvoices.some(invoice => invoice.isPastDue);
  }

  get uniqueInvoices() {
    return this.invoiceItems.map(invoiceItem => invoiceItem.invoice).uniqBy('id');
  }
}
